<template>
    <div class="content-wrap">
        <div class="tab">
            <div :class="['tab-item', curTab === 0 && 'tab-item-act']" @click="curTab = 0">体验预约</div>
            <div :class="['tab-item', curTab === 1 && 'tab-item-act']" @click="curTab = 1">我的预约</div>
        </div>
        <div class="tab-content">
            <transition name="fade-transform" mode="out-in">
                <keep-alive include="appointExpreise">
                    <router-view @myappoint='myappoint'></router-view>
                </keep-alive>
            </transition>
        </div>
    </div>
</template>

<script>

    export default {
        name: "appoint",
        data() {
            return {
                curTab: 0
            }
        },
        watch: {
            curTab(val) {
                if (val === 0) {
                    this.$router.replace({path: '/hvac/talk/appoint'})
                } else if (val === 1) {
                    this.$router.replace({path: '/hvac/talk/myappoint'})
                }
            }
        },
        methods: {
            myappoint () {
                this.curTab = 1
            }
        },
        created () {
           
        }
    }
</script>

<style lang="scss" scoped>
    .content-wrap {
        min-height: 100vh;
        background: #F0F4F1;

        .tab {
            width: 91.2%;
            margin: 40px auto 28px;
            box-sizing: border-box;
            border-radius: 12px;
            border: 2px solid #318544;
            display: flex;
            overflow: hidden;

            .tab-item {
                font-size: 28px;
                font-weight: 400;
                color: #318544;
                line-height: 80px;
                text-align: center;
                width: 50%;
            }

            .tab-item-act {
                background: #318544;
                color: #E5EFE7;
            }
        }
    }

    /*动画*/
    .fade-transform-leave-active,
    .fade-transform-enter-active {
        transition: all 0.4s;
    }
    .fade-transform-enter {
        opacity: 0;
        transform: translateX(-30px);
    }
    .fade-transform-leave-to {
        opacity: 0;
        transform: translateX(30px);
    }
</style>